export const LOGISTICS_OPL_DASHBOARD: string = 'dashboard';
export const LOGISTICS_OPL_TRANSFER: string = 'transfer';
export const LOGISTICS_OPL_TRANSFER_NEW: string = 'new';
export const LOGISTICS_OPL_TRANSFER_ASSIGN: string = 'assign';
export const LOGISTICS_OPL_TRANSFER_DETAIL: string = 'detail';
export const LOGISTICS_OPL_TRANSFER_DETAIL_FROM_TRANSPORTER: string = 'transporter';

export const LOGISTICS_OPL_TRANSFER_REQUEST: string = 'import-request';

export const LOGISTICS_OPL_DETAIL: string = 'detail';

export const LOGISTIC_OPL_TRANSPORTER: string = 'transporter';
export const LOGISTIC_OPL_TRANSPORTER_DETAIL: string = 'detail';

export const LOGISTICS_OPL_CENTER_CAPACITY: string = 'center-capacity';

